import localforage from 'localforage';

import type {
    ChangeTrackerDataKey,
    RegisterEventTrackerDataKey,
} from './firestore';

export const CHANGE_TRACKER_TIMESTAMPS_KEY = 'change-tracker-timestamps';
export const REGISTER_TRACKER_TIMESTAMPS_KEY =
    'register-change-tracker-timestamps';

export type LocalChangeTrackerTimestamps = Record<
    ChangeTrackerDataKey,
    string | undefined
>;

export type RegisterChangeTrackerTimestamps = Record<
    RegisterEventTrackerDataKey,
    string | undefined
>;

export type StockChangeTrackerTimestamps = {
    stockChange?: string;
};

export const getStoredTimestamp = async (
    key = CHANGE_TRACKER_TIMESTAMPS_KEY,
) => {
    try {
        const stored = await localforage.getItem(key);
        return stored ?? {};
    } catch {
        return {};
    }
};

export const setStoredTimestamp = async (
    data: object,
    key = CHANGE_TRACKER_TIMESTAMPS_KEY,
) => {
    return await localforage.setItem(key, data);
};

export const initializeLocalChangeTrackerTimestamps = async () => {
    const recordsToUpdate: ChangeTrackerDataKey[] = [
        'branch',
        'business',
        'businessProperty',
        'categories',
        'discounts',
        'items',
        'measurementUnits',
        'paymentMethod',
        'paymentsGroups',
        'receiptConfiguration',
        'registerConfiguration',
        'invoiceConfiguration',
        'staff',
        'taxes',
        'stock',
        'modifierGroups',
        'collectionAccountTransaction',
    ];
    const now = new Date().toISOString();
    const timestamps: LocalChangeTrackerTimestamps =
        {} as LocalChangeTrackerTimestamps;

    recordsToUpdate.forEach((key) => {
        timestamps[key] = now;
    });

    return setStoredTimestamp(timestamps, CHANGE_TRACKER_TIMESTAMPS_KEY);
};

export const getMostRecentTimestamp = async () => {
    try {
        const changeTracker = await getStoredTimestamp();
        const registerTracker = await getStoredTimestamp(
            REGISTER_TRACKER_TIMESTAMPS_KEY,
        );

        const stored = { ...changeTracker, ...registerTracker };

        if (!stored || Object.keys(stored).length === 0) {
            return null;
        }

        const timestampArray = Object.values(stored)
            .map((value) => {
                return typeof value === 'string'
                    ? new Date(value).getTime()
                    : 0;
            })
            .filter((time) => time > 0);

        return new Date(Math.max(...timestampArray)).toISOString();
    } catch {
        return null;
    }
};
